import { IoIosArrowForward } from "@react-icons/all-files/io/IoIosArrowForward";
import Image from "next/image";
import Link from "next/link";
import { IPlugin } from "../../../types";
import { PopoverDiv } from "./menuPopovers.styles";

interface IPopoverProps {
  isDark?: boolean;
  columns?: { title: string; apps: IPlugin[] }[];
  show?: boolean;
}

export const TypesPopover = ({ isDark, show }: IPopoverProps) => {
  return (
    <PopoverDiv className={`${isDark ? "dark" : ""} ${show ? "show" : ""}`}>
      <div className={`solutions  ${isDark ? "dark" : ""}`}>
        <Link href={"/types/single-elimination-bracket"}>
          Single Elimination
        </Link>
        <Link href={"/types/double-elimination-bracket"}>
          Double Elimination
        </Link>
        <Link href={"/types/march-madness-bracket"}>March Madness</Link>
        <Link href={"/types/round-robin-bracket"}>Round Robin</Link>
        <Link href={"/types/group-stage-bracket"}>Group Stage</Link>
        <Link href={"/types/prediction-bracket"}>Predictions</Link>
        <Link href={"/types/images-bracket"}>Brackets with Images</Link>
        <Link href={"/types/voting-bracket"}>Voting Brackets</Link>
      </div>
    </PopoverDiv>
  );
};

export const VerticalsPopover = ({ isDark, show }: IPopoverProps) => {
  return (
    <PopoverDiv
      className={`popover ${isDark ? "dark" : ""} ${show ? "show" : ""}`}
    >
      <div className={`solutions vertical ${isDark ? "dark" : ""}`}>
        <Link className="span-title" href={"/vertical/american-leagues"}>American Leagues</Link>
        <Link href={"/vertical/american-leagues/nfl-playoff-bracket"}>
          NFL Playoff Bracket
        </Link>
        <Link href={"/vertical/american-leagues/nba-playoff-bracket"}>
          NBA Playoff Bracket
        </Link>
        <Link href={"/vertical/american-leagues/wnba-playoff-bracket"}>
          WNBA Playoff Bracket
        </Link>
        <Link href={"/vertical/american-leagues/nhl-playoff-bracket"}>
          NHL Playoff Bracket
        </Link>
        <Link href={"/vertical/american-leagues/mlb-playoff-bracket"}>
          MLB Playoff Bracket
        </Link>
      </div>
      <div className={`solutions vertical ${isDark ? "dark" : ""}`}>
        <Link className="span-title" href={"/vertical/international"}>International</Link>
        <Link href={"/vertical/international/champions-league-bracket"}>
          Champions League Bracket
        </Link>
        <Link href={"/vertical/international/world-cup-bracket"}>
          World Cup Bracket
        </Link>
      </div>
      <div className={`solutions vertical ${isDark ? "dark" : ""}`}>
        <Link className="span-title" href={"/vertical/tennis"}>Tennis</Link>
        <Link href={"/vertical/tennis/wimbledon-bracket"}>
          Wimbledon Bracket
        </Link>
        <Link href={"/vertical/tennis/australian-open"}>
          Australian Open Bracket
        </Link>
        <Link href={"/vertical/tennis/roland-garros"}>
          Roland Garros Bracket
        </Link>
        <Link href={"/vertical/tennis/us-open"}>US Open Bracket</Link>
      </div>
      <div className={`solutions vertical ${isDark ? "dark" : ""}`}>
        <Link className="span-title" href={"/vertical/e-sports"}>E-Sports</Link>
        <Link href={"/vertical/e-sports/valorant-brackets"}>
          Valorant Brackets
        </Link>
        <Link href={"/vertical/e-sports/fifa-brackets"}>FIFA Brackets</Link>
        <Link href={"/vertical/e-sports/league-of-legends-brackets"}>
          League of Legends Bracket
        </Link>
        <Link href={"/vertical/e-sports/minecraft-brackets"}>
          Minecraft Brackets
        </Link>
        <Link href={"/vertical/e-sports/tekken-8-brackets"}>
          Tekken 8 Brackets
        </Link>
      </div>
    </PopoverDiv>
  );
};
